'use es6';

export const OPEN_DELAY = 600;